import React, { useEffect, useState } from 'react';
import b from 'b_';

import { TEXT_MARKUP_TYPE, UI_KIT_HEADER_TYPOGRAPHY, UI_KIT_TEXT_TYPOGRAPHY } from '../../constants';
import { H1, H2, H3 } from '../../header-text/header-text';
import QrGenerator from '../../qr-generator/qr-generator';
import Text from '../../text/text';
import LiveIndicator, { LIVE_INDICATOR_SIZE } from '../../live-indicator/live-indicator';
import { SimpleCallback } from '../../../typings';
import { Button } from '../../button/button';

import './quiz__start-screen.scss';

const ANIMATION_DURATION = 2000;

interface Props {
    pin: string | null;
    onlineStudentsCount: number;
    handleMainButtonClick?: SimpleCallback;
}

const QuizStartScreen = (props: Props) => {
    const { pin, onlineStudentsCount = 0, handleMainButtonClick } = props;
    const [isAnimate, setAnimate] = useState(false);

    useEffect(() => {
        if (onlineStudentsCount) {
            setAnimate(true);
            setTimeout(() => setAnimate(false), ANIMATION_DURATION);
        }
    }, [onlineStudentsCount]);

    return (
        <div className="quiz__start-screen">
            <div className="quiz__start-screen-instructions">
                <H1
                    id="quiz.instructions.gameConnectTitle"
                    mix="quiz__start-screen-text"
                    type={TEXT_MARKUP_TYPE.MARKDOWN}
                    typography={UI_KIT_HEADER_TYPOGRAPHY.headlineMBold}
                />
                <div className="quiz__students-count">
                    <H2
                        id={`quiz.studentsConnected.${Boolean(onlineStudentsCount)}`}
                        mix="quiz__students-count-title"
                        type={TEXT_MARKUP_TYPE.MARKDOWN}
                        typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSMedium}
                    />
                    <div className={b('quiz', 'students-count-badge', { 'no-students': !onlineStudentsCount })}>
                        <Text typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLMedium}>{onlineStudentsCount}</Text>
                        {isAnimate && (
                            <LiveIndicator
                                isInfinite={false}
                                mix="quiz__students-count-animation"
                                size={LIVE_INDICATOR_SIZE.L}
                            />
                        )}
                    </div>
                </div>
                <div className="quiz__start-screen-steps">
                    <div className="quiz__start-screen-step" data-step-number="1">
                        <H3
                            id="quiz.instructions.scanQrOrgoToUrl"
                            mix="quiz__start-screen-text"
                            type={TEXT_MARKUP_TYPE.MARKDOWN}
                            typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXSMedium}
                        />
                        <H1
                            id="education.yandex.ru/kids/q"
                            mix="quiz__start-screen-text quiz__start-screen-text_type_link"
                            type={TEXT_MARKUP_TYPE.MARKDOWN}
                            typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXLBold}
                        />
                    </div>
                    <div className="quiz__start-screen-step" data-step-number="2">
                        <H3
                            id="quiz.instructions.enterRoomPinCode"
                            mix="quiz__start-screen-text"
                            type={TEXT_MARKUP_TYPE.MARKDOWN}
                            typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXSMedium}
                        />
                        <H1
                            mix="quiz__start-screen-text"
                            type={TEXT_MARKUP_TYPE.MARKDOWN}
                            typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXLBold}
                        >
                            {pin}
                        </H1>
                    </div>
                </div>
                <Button
                    disabled={!onlineStudentsCount}
                    onClick={handleMainButtonClick}
                    rounded
                    size={Button.SIZE.M}
                    view={Button.VIEW.ACTION}
                >
                    <Text id="quiz.startScreen.startButton" />
                </Button>
            </div>
            <div className="quiz__connect">
                <H2
                    id="quiz.instructions.howToConnect"
                    mix="quiz__qr-code-header"
                    typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSRegular}
                />
                <div className="quiz__qr-code-wrapper">
                    <QrGenerator
                        mix="quiz__qr-code"
                        size={QrGenerator.QR_CODE_SIZE.XL}
                        url={`https://education.yandex.ru/kids/quiz?room=${pin}`}
                    />
                </div>
            </div>
        </div>
    );
};

export default QuizStartScreen;
